<script>
export default {
  props: {
    header: {
      type: Object
    },
    state: {
      type: Boolean,
      default: null
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return { dialog: false }
  },
  watch: {
    loading(newValue, oldValue) {
      // close dialog when loading was set from true to false
      // loading change when api-call was fired (set loading to true) and finished (set loading to false)
      if (oldValue && !newValue) this.dialog = false
    }
  },
  methods: {
    toggle(state) {
      this.$emit('onToggle', state)
    }
  }
}
</script>
<template>
  <v-tooltip top>
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" class="d-flex justify-end align-center" v-on="on">
        <v-icon v-if="'icon' in header">{{ header.icon }}</v-icon>
        <span v-if="'text' in header" class="align-center pr-1">{{ header.text }}</span>
        <v-dialog v-model="dialog" max-width="500" :persistent="loading">
          <v-card>
            <DialogBaseColoredTitle color="primary">{{$t('component.profile.administrationManagement.set.for.all.members') }}</DialogBaseColoredTitle>
            <v-divider></v-divider>
            <DialogBaseText>{{ $t('component.profile.administrationManagement.records.are.set.as.follows') }}</DialogBaseText>
            <v-divider></v-divider>
            <DialogBaseActions>
              <v-btn
                color="secondary"
                :loading="loading"
                @click="dialog = false">
                {{$t('button.cancel')}}</v-btn>
              <v-spacer />
              <v-btn
                v-if="state || state === null"
                :loading="loading"
                color="primary"
                @click="toggle(false)"
              >{{ $t('button.uncheck.all') }}</v-btn>
              <v-spacer v-if="!state" />
              <v-btn
                v-if="!state"
                :loading="loading"
                color="primary"
                @click="toggle(true)"
              >{{ $t('button.activate.all') }}</v-btn>
            </DialogBaseActions>
          </v-card>
        </v-dialog>
        <v-checkbox
          :input-value="state"
          :indeterminate="state === null"
          hide-details
          class="font-weight-regular mt-0"
          @click.native.prevent.stop.capture="dialog = true"
        />
      </div>
    </template>
    <span>{{ $t(`component.backoffice.userManagementTable.tooltip.${header.value}`) }}</span>
  </v-tooltip>
</template>
